import { useState } from "react";
import type { Me } from "../../shared/models";
import { api } from "../data/api";
import { clearSnapshots } from "../data/persist";

// "Try the demo" (worker/lib/demo.ts): a made-up family to show Kinmantle to
// friends without a Google account. Saved snapshots belong to whichever
// household was showing, so they're cleared on the way in and out.

export function TryDemoButton() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const start = async () => {
    setBusy(true);
    setError(null);
    try {
      await api("/auth/demo", { method: "POST", body: {} });
    } catch (e) {
      setError(`The demo didn’t start (${e instanceof Error ? e.message : "unknown error"}). Please try again.`);
      setBusy(false);
      return;
    }
    // Make sure the browser kept the demo cookie before reloading, so a refused
    // cookie shows a reason instead of quietly landing back here.
    const me = await api<Me>("/me").catch(() => null);
    if (!me?.demo) {
      setError("This browser didn’t keep the demo sign-in. Check that cookies are allowed for this site, then try again.");
      setBusy(false);
      return;
    }
    clearSnapshots();
    window.location.href = "/";
  };
  return (
    <>
      <button className="btn btn-lg" onClick={start} disabled={busy}>
        {busy ? "Setting up the demo…" : "Try the demo"}
      </button>
      {error && <p className="error-text">{error}</p>}
    </>
  );
}

export async function exitDemo() {
  await api("/auth/demo/exit", { method: "POST", body: {} }).catch(() => undefined);
  clearSnapshots();
  window.location.href = "/";
}

/** Always visible in the demo, so nobody mistakes the sample family for a real one. */
export function DemoBadge() {
  return (
    <div className="demo-badge" role="status">
      <span>
        <strong>Demo</strong> · a sample family; changes are cleared after a while
      </span>
      <button className="btn btn-sm" onClick={() => void exitDemo()}>
        Exit demo
      </button>
    </div>
  );
}
